module.exports = __webpack_public_path__ + "img/buy-crypto.9bcbcf35.svg";